import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";
import { createLocationSearch, GlobalSearchProps } from "./GlobalSearch";

import {
  addressesAutocompleteSection,
  parcelsAutocompleteSection,
  savedSitesAutocompleteSection,
  titlesAutocompleteSection,
} from "./sections";

const GlobalSearchUK = createLocationSearch({
  placeholder: "Search for an address, title or saved site",
  sections: [addressesAutocompleteSection, titlesAutocompleteSection, savedSitesAutocompleteSection],
});

const GlobalSearchUS = createLocationSearch({
  placeholder: "Search for an address, parcel or saved site",
  sections: [addressesAutocompleteSection, parcelsAutocompleteSection, savedSitesAutocompleteSection],
});

export function GlobalSearch(props: Omit<GlobalSearchProps, "sections">) {
  const isUSUser = hasFeature(Feature.usAccess);

  if (isUSUser) {
    return <GlobalSearchUS {...props} />;
  } else {
    return <GlobalSearchUK {...props} />;
  }
}
